import { EmployeeProps, Roles } from '../../../interfaces/employee_type';
import { useNavigate } from "react-router-dom"
import { checkEmployeeHierarchy } from "../../../api/utils";
import { useAuth } from "../../../App"
import { EmployeeFormBase } from './EmployeeFormBase';
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { createEmployee } from '@/api/employee';
import {Error_Component} from "@/components/misc.tsx";

// TODO: This only creates a user, not update it.
// and it's being used on the update employee page.
// We need to fix this.

const employeeSchema = z.object({
    name: z.string().min(1, {message: "Name is required"}),
    email: z.string().email({message: "Invalid email address"}),
    role: z.string().min(1, {message: "Role is required"}),
    password: z.string().min(8, {message: "Password must be at least 8 characters long"}),
    re_password: z.string().min(8, {message: "Password must be at least 8 characters long"}),
})

export type EmployeeFormData = z.infer<typeof employeeSchema>

export function CreateEmployeeForm({employee, method, isChangePassword = false}: {employee?: EmployeeProps, method: "POST" | "PUT", isChangePassword?: boolean }) {
    const { user } = useAuth()

    const employeeData: EmployeeProps = employee ?? {
        name: '',
        email: '',
        role: 'CEO',
        password: '',
        username: '',
    }

    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isSubmitting },
        setError,
    } = useForm<EmployeeFormData>({
        defaultValues: employeeData,
        resolver: zodResolver(employeeSchema),
    })

    const roleHierarchy = checkEmployeeHierarchy(user?.role ?? "CEO")
    const navigate = useNavigate()

    const onSubmit = async (data: EmployeeFormData) => {
        if (data.password !== data.re_password) {
            setError("re_password", {message: "Passwords do not match"})
            return
        }

        if (roleHierarchy != "ADMIN" && roleHierarchy != "IT") {
            setError("root", {message: "You are not authorized to create or update employees"})
            return
        }
        
        const response = await createEmployee({
            name: data.name,
            email: data.email,
            role: data.role as Roles,
            password1: data.password,
            password2: data.re_password,
            username: data.email,
        })

        if (response.operation == "COMPLETED") {
            alert("Employee created successfully")
            navigate("/employees")
        } else if (response.status == 400) {
            let errors = "";

            if (response.data?.username !== undefined)
                errors += (response.data.username as string)
            if (response.data?.email !== undefined)
                errors += (response.data.email as string)

            setError("root", {message: errors})
        } else {
            setError("root", {message: "Something went wrong"})
        }
    }

    return (
        <>
            {errors.root && <Error_Component errorString={errors.root.message || "An error has occurred"} />}

            <EmployeeFormBase
                onSubmit={handleSubmit(onSubmit)}
                employee={employeeData}
                method={method}
                isChangePassword={isChangePassword}
                canChangeRole={(roleHierarchy === "ADMIN" || roleHierarchy === "IT")}
                isProcessing={isSubmitting}
                register={register}
                control={control}
                errors={errors}
            />
        </>
    )
}